export class CommentModel {
    id:number;
    text:string;
}
